/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Proxy_Status_Importing_MediaInputs */



/**
* | output |
* | --- |
* | "Importing media from URL..." |
*
* @param {Iconik_Proxy_Status_Importing_MediaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_proxy_status_importing_media = /** @type {((inputs?: Iconik_Proxy_Status_Importing_MediaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Proxy_Status_Importing_MediaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation des medias depuis l'URL...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Medien werden von URL importiert...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione di contenuti multimediali dall'URL...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт медиафайлов по URL...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importando medios desde URL...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("从 URL 导入媒体...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("URL からメディアをインポートしています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यूआरएल से मीडिया आयात किया जा रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importando mídia de URL...")
	return /** @type {LocalizedString} */ ("Importing media from URL...")
});